import { FormationTopBase } from './base/formation-top-base';

export class FormationTop extends FormationTopBase { }